import React, { useMemo } from "react";
import { CustomTable } from "../../../../../../Common/CustomTable";

const RoomDetailsWithCheckOut = ({ data, summaryData }) => {
  const rentDetailsColumns = useMemo(() => [
    { Header: "#", accessor: "index" },
    { Header: "From Date", accessor: "fromDate" },
    { Header: "To Date", accessor: "toDate" },
    { Header: "NoD", accessor: "noOfDays" },
    { Header: "Rent/Day", accessor: "rentPerDay" },
    { Header: "Discount", accessor: "discount" },
    { Header: "Total Rent", accessor: "totalRent" },
  ], []);

  const fromDate = data?.check_in?.split(" ")[0];
  const toDate = data?.check_out?.split(" ")[0];
  const noOfDays = Math.ceil(
    (new Date(data?.check_out) - new Date(data?.check_in)) / (1000 * 60 * 60 * 24)
  );

  const rentDetailsData = useMemo(() => [
    {
      index: 1,
      fromDate,
      toDate,
      noOfDays,
      rentPerDay: `₹${data?.price}`,
      discount: "₹0.00", // If available from API, replace here
      totalRent: `₹${parseFloat(data?.price) * noOfDays}`,
    },
  ], [data]);


  const mainData = useMemo(() => [
    {
      roomNo: (
        <>
          <strong>{data?.room_number}</strong>
          <div>{data?.room_type}</div>
        </>
      ),
      date: `${fromDate} to ${toDate}`,
      roomType: data?.room_type,
      guestDetails: `Adults: ${data?.capacity || 1}`,
      rentDetails: <CustomTable columns={rentDetailsColumns} data={rentDetailsData} />,
      taxDetails: (
        <>
          <div>GST (12%): ₹{((parseFloat(data?.price || 0) * noOfDays) * 0.12).toFixed(2)}</div>
        </>
      ),
      totalAmount: `₹${data?.total_amount}`,
    },
  ], [data, fromDate, toDate, rentDetailsColumns, rentDetailsData]);

  const {
    totalRoomCharges,
    totalServiceCharges,
    totalRestaurantCharges,
    totalTaxAmount,
    totalDiscounts,
    servicesData = [],
    restaurantData = [],
    totalAmountPaid
  } = summaryData?.data;


  return (
    <div className="col-md-12">
      <div className="card">
        <div className="card-header">
          <h6 className="card-title">Bill Details</h6>
        </div>
        <div className="card-body">

          {/* <h3>Room Details</h3> */}
          <table style={{ width: "100%", borderCollapse: "collapse" }}>
            <thead>
              <tr style={{ borderBottom: "1px solid #ccc", textAlign: "left" }}>
                <th style={{ padding: 8 }}>Item Type</th>
                <th style={{ padding: 8 }}>Description</th>
                <th style={{ padding: 8 }}>Details</th>
                <th style={{ padding: 8 }}>Price</th>
                <th style={{ padding: 8 }}>Qty/Nights</th>
                <th style={{ padding: 8 }}>Sub Total</th>
                <th style={{ padding: 8 }}>Discount</th>
                <th style={{ padding: 8 }}>Total</th>
                <th style={{ padding: 8 }}>Paid</th>
              </tr>
            </thead>
            <tbody>
              {summaryData?.data?.roomsPrice?.map(
                (
                  { price_per_night, total_nights, total_amount, payment_status, discount, room },
                  index
                ) => (
                  <tr key={index} style={{ borderBottom: "1px solid #eee" }}>
                    <td style={{ padding: 8 }}>Room</td>
                    <td style={{ padding: 8 }}>{room?.room_type || "-"}</td>
                    <td style={{ padding: 8 }}>Room {room?.room_number || "-"}</td>
                    <td style={{ padding: 8 }}>&#8377;{price_per_night}</td>
                    <td style={{ padding: 8 }}>{total_nights || "-"} nights</td>
                    <td style={{ padding: 8 }}>&#8377;{total_amount}</td>
                    <td style={{ padding: 8 }}>&#8377;{discount}</td>
                    <td style={{ padding: 8 }}>&#8377;{total_amount - discount}</td>
                    <td style={{ padding: 8 }}>{payment_status ? "Yes" : "No"}</td>
                  </tr>
                )
              )}
              {servicesData?.map(
                (
                  { price_per_night, quantity, total_amount, payment_status, discount, service },
                  index
                ) => (
                  <tr key={index} style={{ borderBottom: "1px solid #eee" }}>
                    <td style={{ padding: 8 }}>Service</td>
                    <td style={{ padding: 8 }}>{service?.package_name || "-"}</td>
                    <td style={{ padding: 8 }}>{"-"}</td>
                    <td style={{ padding: 8 }}>&#8377;{price_per_night}</td>
                    <td style={{ padding: 8 }}>{quantity || "-"} </td>
                    <td style={{ padding: 8 }}>&#8377;{total_amount}</td>
                    <td style={{ padding: 8 }}>-</td>
                    <td style={{ padding: 8 }}>&#8377;{total_amount}</td>
                    <td style={{ padding: 8 }}>{payment_status ? "Yes" : "No"}</td>
                  </tr>
                )
              )}

              {restaurantData?.map(
                (
                  {
                    price_per_night,
                    quantity,
                    total_amount,
                    payment_status,
                    discount,
                    tip,
                    gstAmount,
                    serviceCharge,
                    restaurant,
                  },
                  index
                ) => {
                  const subTotal = price_per_night * quantity;
                  const serviceChargeAmount = ((subTotal * serviceCharge)/100);

                  return (
                    <tr key={index} style={{ borderBottom: "1px solid #eee" }}>
                      <td style={{ padding: 8 }}>Restaurant</td>
                      <td style={{ padding: 8 }}>{restaurant?.name || "-"}</td>
                      <td style={{ padding: 8 }}>{restaurant?.description || "-"}</td>
                      <td style={{ padding: 8 }}>&#8377;{price_per_night?.toFixed(2) || "0.00"}</td>
                      <td style={{ padding: 8 }}>{quantity || "-"}</td>
                      <td style={{ padding: 8 }}>&#8377;{subTotal.toFixed(2)}</td>
                      <td style={{ padding: 8 }}>
                        Tip: &#8377;{tip.toFixed(2)}<br />
                        GST: &#8377;{gstAmount.toFixed(2)}<br />
                        SC: &#8377;{serviceChargeAmount.toFixed(2)}<br />
                        Discount: -&#8377;{((subTotal*discount)/100).toFixed(2)}
                      </td>
                      <td style={{ padding: 8 }}>&#8377;{total_amount?.toFixed(2)}</td>
                      <td style={{ padding: 8 }}>{payment_status ? "Yes" : "No"}</td>
                    </tr>
                  );
                }
              )}
            </tbody>
            <tfoot>
              <tr>
                <td colSpan="8" className="label">
                  Room Total (after discount)
                </td>
                <td>&#8377;{totalRoomCharges - totalDiscounts}</td>
              </tr>
              <tr>
                <td colSpan="8" className="label">
                  Service Total
                </td>
                <td>&#8377;{parseFloat(totalServiceCharges).toFixed(2)}</td>
              </tr>
              {totalRestaurantCharges > 0 && (
                <tr>
                <td colSpan="8" className="label">
                  Order Total
                </td>
                <td>&#8377;{totalRestaurantCharges}</td>
              </tr>)}
              <tr>
                <td colSpan="8" className="label">
                  Tax
                </td>
                <td>&#8377;{parseFloat(totalTaxAmount).toFixed(2)}</td>
              </tr>
              <tr>
                <td colSpan="8" className="label">
                  Grand Total
                </td>
                <td>&#8377;{parseFloat(totalRoomCharges + totalServiceCharges + totalRestaurantCharges + totalTaxAmount - totalDiscounts).toFixed(2)}</td>
              </tr>
              <tr>
                <td colSpan="8" className="label">
                  Paid 
                </td>
                <td>&#8377;{parseFloat(totalAmountPaid).toFixed(2)}</td>
              </tr>
              <tr>
                <td colSpan="8" className="label">
                  Unpaid
                </td>
                <td>&#8377;{Math.abs(parseFloat(totalRoomCharges + totalServiceCharges + totalRestaurantCharges + totalTaxAmount - totalDiscounts - totalAmountPaid).toFixed(2))}</td>
              </tr>
            </tfoot>
          </table>
          <br />
        </div>
      </div>
    </div>
  );
};

export default RoomDetailsWithCheckOut;
